import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { TreetopPropertiesProvider } from 'shared/util-common';

import { LanguageDto } from '@treetop/shared/model';

import { LoadingService } from '../infrastructure/loading.service';
import { MessagesService } from '../infrastructure/messages.service';
@Injectable({
  providedIn: 'root',
})
export class LanguageStore {
  private http = inject(HttpClient);
  private loading = inject(LoadingService);
  private messages = inject(MessagesService);
  private translocoService = inject(TranslocoService);

  baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api`;

  private allLanguagesSubject$ = new BehaviorSubject<LanguageDto[]>([]);
  allLanguages$: Observable<LanguageDto[]> = this.allLanguagesSubject$.asObservable();

  private loadLanguages(subject$: BehaviorSubject<LanguageDto[]>): void {
    const loadLanguages$ = this.http.get<LanguageDto[]>(`${this.baseUrl}/languages`).pipe(
      catchError((err) => {
        this.messages.showError(this.translocoService.translate('LoadLanguages'), undefined);
        return throwError(err);
      }),
      tap((languages) => {
        subject$.next(languages);
      }),
    );
    this.loading.showLoaderUntilCompleted(loadLanguages$).subscribe();
  }

  public loadAllLanguages(): void {
    this.loadLanguages(this.allLanguagesSubject$);
  }

  public getDefaultLanguages(): Observable<string[]> {
    return this.http.get<LanguageDto[]>(`${this.baseUrl}/languages`).pipe(
      map((languages: LanguageDto[]) => {
        return languages.map((lang) => lang.code).filter((langCode) => langCode.length === 2);
      }),
    );
  }

  public getRegionalLanguages(): Observable<string[]> {
    return this.http.get<LanguageDto[]>(`${this.baseUrl}/languages`).pipe(
      map((languages: LanguageDto[]) => {
        return languages.map((lang) => lang.code).filter((langCode) => langCode.length > 2);
      }),
    );
  }
}
